import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  StackDivider,
  Text,
  VStack,
} from "@chakra-ui/react";
import { AnimateSharedLayout } from "framer-motion";
import React, { useState } from "react";
import BurgerMenu from "../components/BurgerMenu";

const MobileLayout = ({ children }) => {
  const [menu, setMenu] = useState(false);

  return (
    <Grid templateColumns="repeat(4, 1fr)">
      <GridItem colSpan="4">
        <Box p="5" maxHeight="calc(100vh - 0px)" overflowY="auto">
          <Flex
            p="3 0"
            alignItems="center"
            justifyContent="space-between"
            margin="10px 0"
          >
            <Box>
              <Text fontSize="3xl">POTRAN</Text>
            </Box>
            <BurgerMenu />
          </Flex>
          <AnimateSharedLayout>{children}</AnimateSharedLayout>
        </Box>
      </GridItem>
    </Grid>
  );
};

export default MobileLayout;
